import { DynamicQueryEvent, DynamicQueryEventTypes } from 'common/dynamicquery/dynamic-query-events.factory';
import { Injectable } from '@angular/core';
import { AutoAnswersResults } from 'common/xislivechat/models/auto-answers-results';
import { AutoAnswersQuestions } from 'common/xislivechat/models/auto-answers-questions';
import { filter, map } from 'rxjs/operators';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';

@Injectable()
export class AutoAnswersService {

  constructor(private _dynamicQuery: DynamicQueryAdapterService,
              private _dynamicQueryDecorator: DynamicQueryDecoratorService) {
  }

  createAAQuestionsObservableByChatId(chatId) {
    if (!chatId) {
      throw new Error('Missing chatId!');
    }

    const innerContext = this;
    const aaQuestionsObservable = innerContext._dynamicQuery.getQuery('autoAnswersQuestionsByChatID', { ChatID: chatId });
    return innerContext._dynamicQueryDecorator.create(aaQuestionsObservable, AutoAnswersQuestions.wrap).pipe(
      filter((dynamicQueryEvent: DynamicQueryEvent) => {
        return dynamicQueryEvent.event !== DynamicQueryEventTypes.DONE;
      }),
      map((result: DynamicQueryEvent) => result.data)
    );
  }

  createAAResultsObservableByChatId(chatId) {
    if (!chatId) {
      throw new Error('Missing chatId!');
    }

    const innerContext = this;
    const aaResultsObservable = innerContext._dynamicQuery.getQuery('autoAnswersResultsByChatID', { ChatID: chatId });
    return innerContext._dynamicQueryDecorator.create(aaResultsObservable, AutoAnswersResults.wrap).pipe(
      filter((dynamicQueryEvent: DynamicQueryEvent) => {
        return dynamicQueryEvent.event !== DynamicQueryEventTypes.DONE;
      }),
      map((result: DynamicQueryEvent) => result.data)
    );
  }
}
